import isEmpty from "assets/scripts/utils/isEmpty";
const R_ZIP = /^\d{5}(?:[-\s]\d{4})?$/;
export default function validZip(value) {
    return isEmpty(value) || R_ZIP.test(value);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/validZip.ts